import AccountBalanceOutlinedIcon from '@material-ui/icons/AccountBalanceOutlined';
import ChatIcon from '@material-ui/icons/Chat';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import GradeIcon from '@material-ui/icons/Grade';
import InsertChartIcon from '@material-ui/icons/InsertChart';
import CalendarViewDayIcon from '@material-ui/icons/CalendarViewDay';
import NotificationsIcon from '@material-ui/icons/Notifications';
import WarningIcon from '@material-ui/icons/Warning';
import PersonIcon from '@material-ui/icons/Person';

// export const APP_URL = `https://localhost:8000/api/v1/`;
import {AE, BS, CA, IN, OM, PK, QA, SA, US} from '../assets/images/flags'

export const APP_DOMAIN_PREFIX = `https://www.agrilivemarket.com`;
export const API_URL = process.env.REACT_APP_API_URL || `${APP_DOMAIN_PREFIX}/rest`;
// Standalone JWT auth microservice (auth-service/), proxied by Caddy at
// /authapi/* with the prefix stripped before forwarding to the service.
export const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL || `${APP_DOMAIN_PREFIX}/authapi`;
export const AUTH_TOKENS_STORAGE = 'auth_tokens';
export const FILE_BASE_URL = 'http=//localhost=9000/';

export const LABELS = {
  GO_BACK: '← Back',
  LOGOUT: '↶ Logout',
  LOGIN: 'Login',
  SIGNUP: 'Sign Up',
  REGISTER: 'Create User',
  EMAIL: 'Email Address',
  NAME: 'Username',
  FULL_NAME: 'Full Name',
  PASSWORD: 'Password',
  CONFIRM_PASSWORD: 'Confirm Password'
};
export const PASSWORD = {
  passwordLength: 6,
  passwordLengthError: 'password must be 6-20 characters'
}
export const REGISTER = {
  SUCCESS_HEADER: "Success",
  SUCCESS_MESSAGE: "User Created Successfully!",
  FAILURE_HEADER: "Failure",
  FAILURE_MESSAGE: "Cannot Create User! User may already have been created with the given email!"
};
export const REGEXP_EMAIL = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2;3})+$/;
export const C_OTC_STORAGE = 'user_storage';

export const sidebarTabsList = [
  {text: 'dashboard', key: 'dashboard', icon: AccountBalanceOutlinedIcon},
  {text: 'My Services', key: 'myservices', icon: InsertChartIcon},
  {text: 'My products', key: 'myproducts', icon: CalendarViewDayIcon},
  {text: 'orders', key: 'orders', icon: AccountBalanceOutlinedIcon},
  {text: 'product bid', key: 'bids', icon: FormatAlignLeftIcon},
  //{text: 'chat', key: 'dashboard', icon: ChatIcon},
  {text: 'my Requirements', key: 'myRequirements', icon: GradeIcon},
  {text: 'save alerts', key: 'savedAlert', icon: NotificationsIcon},
  // {text: 'my harvest', key: 'myharvest', icon: NoteIcon},
  {text: 'my bids', key: 'myBids', icon: WarningIcon},
  // {text: 'setting', key: 'userprofile', icon: SettingsIcon},
  {text: 'User Profile', key: 'userprofile', icon: PersonIcon},
];

export const jobStatus = [
  'pending', 'assigned', 'in route', 'delivered', 'completed',
];

export const userRoles = [
  {value: 'Crops & Grains', text: 'Crops & Grains'},
  {value: 'Fruits & Vegetables', text: 'Fruits & Vegetables'},
  {value: 'Livestock & Dairy', text: 'Livestock & Dairy'},
  {value: 'Fisheries & Aquaculture', text: 'Fisheries & Aquaculture'},
  {value: 'Agri Services & Inputs', text: 'Agri Services & Inputs'},
]
export const flags = [
  {text: 'UAE', value: 'AE', flag: AE},
  {text: 'PAK', value: 'PK', flag: PK},
  {text: 'US', value: 'US', flag: US},
  {text: 'CA', value: 'CA', flag: CA},
  {text: 'IN', value: 'IN', flag: IN},
  {text: 'oman', value: 'OM', flag: OM},
  {text: 'qatar', value: 'QA', flag: QA},
  {text: 'saudi arabia', value: 'SA', flag: SA},
  {text: 'bahrain', value: 'BA', flag: BS},
  // {text: 'purtgal', value: '2',flag:CA},
]
export const userStatus = [
  {text: 'Active', value: '1'},
  {text: 'In-Active', value: '0'},
]

export const YesNoOption = [
  {text: 'Yes', value: '1'},
  {text: 'No', value: '0'},
]
export const expiryOfferOption = [
  {text: '6 Hour', value: '6h'},
  {text: '12 Hour', value: '12h'},
  {text: '1 Day', value: '1d'},
]
export const measurementUnitsOption = [
  {text: 'grams', value: 'grams'},
  {text: 'kilos', value: 'kilos'},
  {text: 'munds', value: 'munds'},
  {text: 'liters', value: 'liters'},
  {text: 'units', value: 'units'},
  {text: 'dozen', value: 'dozen'},
  {text: 'tons', value: 'tons'},
  {text: 'pair', value: 'pair'},
  {text: 'container', value: 'container'},
  {text: 'packet', value: 'packet'},
]

export const quantityUnitsOption = [
  {text: 'kg', value: 'kg'},
  {text: 'ltr', value: 'ltr'},
]

export const alertCategoryOption = [
  {text: 'Crops & Grains', value: 'crops_grains'},
  {text: 'Fruits & Vegetables', value: 'fruits_vegetables'},
  {text: 'Livestock & Dairy', value: 'livestock_dairy'},
  {text: 'Fisheries & Aquaculture', value: 'fisheries_aquaculture'},
  {text: 'Agri Services & Inputs', value: 'agri_services_inputs'},
]
export const alertScopeOption = [
  {text: 'global', value: 'global'},
  {text: 'local', value: 'local'},
]
export const alertTypeOption = [
  {text: 'Information', value: 'information'},
  {text: 'Alert(Hazard)', value: 'Alert(Hazard)'},
  {text: 'Warning', value: 'Warning'},
  {text: 'other', value: 'other'},
]

export const searchAlertTypeOption = [
  {text: 'daily', value: 'daily'},
  {text: 'weekly', value: 'weekly'},
  {text: 'monthly', value: 'monthly'},
]

export const otherSectorsOption = [
  {text: 'crops & grains', value: 'crops & grains'},
  {text: 'fruits & vegetables', value: 'fruits & vegetables'},
  {text: 'livestock & dairy', value: 'livestock & dairy'},
  {text: 'fisheries & aquaculture', value: 'fisheries & aquaculture'},
  {text: 'consultancy', value: 'consultancy'},
  {text: 'equipment vendor', value: 'equipment vendor'},
  {text: 'transportation services', value: 'transportation services'},
  {text: 'seed vendor', value: 'seed vendor'},
  {text: 'grading services', value: 'grading services'},
]

export const userCountryOption = [
  {text: 'UAE', value: 'ue', icon: AE},
  {text: 'Pakistan', value: 'PK', icon: PK},
  {text: 'KSA', value: '1'},
  {text: 'OMAN', value: '2'},
  {text: 'Bahrain', value: '3'},
  {text: 'Bangladesh', value: '4'},
  {text: 'India', value: '5'},
  {text: 'Qatar', value: '6'},
  {text: 'Singapore', value: '6'},
  {text: 'South Africa', value: '8'},
  {text: 'Tanzania', value: '9'},
  {text: 'Ethiopia', value: '10'},
  {text: 'Kenya', value: '11'},
  // todo canda, UK, china USA
]


export const bidsAgainst = 'bidsAgainst'

export const farmingDiscount = '5'
export const fruitsVegDiscount = '20'
export const fisheryDiscount = '15'
export const liveStockDiscount = '25'
export const servicesDiscount = '10'

export const currencyOption = [
  {text: 'Pakistani rupee', value: 'PKR'},
  {text: 'Indian Rupee ', value: 'INR'},
  {text: 'Emirati Dirham', value: 'AED'},
  {text: 'United States Dollar', value: 'USD'},
  {text: 'British pound sterling', value: 'GBP'},
  {text: 'Canadian dollar', value: 'CAD'},
  {text: 'Omani rial', value: 'OMR'},
  {text: 'Qatari Riyal', value: 'QAR'},
  {text: 'Bangladeshi Taka ', value: 'BDT'},
  {text: 'Rand', value: 'ZAR'},
  {text: 'Birr', value: 'ETB'},
  {text: 'Shillings', value: 'KES'},
  {text: 'Singapore dollar', value: 'SGD'},
  {text: 'Bahraini dinar', value: 'BHD'},
  {text: 'Saudi riyal', value: 'SAR'},
  {text: 'Chinese Yuan', value: 'CNY'},
  {text: 'European euro ', value: 'EUR'},
]
